import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 7h-8v6h8V7zm4-4H1v17.98h22V3zm-2 16.01H3V4.98h18v14.03z"
}), 'PictureInPictureSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PictureInPictureSharp.js
// module id = 5479
// module chunks = 2